import { render, staticRenderFns } from "./LengthLabel.vue?vue&type=template&id=534a13a9&"
import script from "./LengthLabel.vue?vue&type=script&lang=ts&"
export * from "./LengthLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports